import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../Cupos/actions'
import { Field } from 'redux-form'
import {
  renderSelectField
} from '../../fieldRenderers'

class TipoCupoDropdown extends Component {
  constructor (props) {
    super(props)
    this.renderTiposCupos = this.renderTiposCupos.bind(this)
  };

  componentDidMount () {
    this.props.requestTiposCupos()
  };

  onSelect (tipoCupo) {
    if (tipoCupo) {
      this.props.setTipoCupo(tipoCupo.target.value)
    }
  }

  renderTiposCupos () {
    const {
      tiposCupos
    } = this.props || []
    return [
      (<option
        value='UNDEF'
        key='UNDEF'
      >
      Elija un tipo de cupo
      </option>),
      ...tiposCupos.map(tipoCupo => {
        return (
          <option
            value={tipoCupo.nombreCorto}
            key={tipoCupo.nombreCorto}
          >
            {tipoCupo.nombre}
          </option>
        )
      })
    ]
  };

  render () {
    const {
      disabled = false
    } = this.props

    return (
      <Field
        name='Tipo de Cupo'
        label='Tipo de Cupo'
        component={renderSelectField}
        disabled={disabled}
        placeholder='Elija un tipo de cupo'>
        {this.renderTiposCupos()}
      </Field>
    )
  }
}

const mapStateToProps = (state) => ({
  tiposCupos: state.cupos.tiposCupos || []
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(TipoCupoDropdown)
